"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borghetto-santo-spirito": {
    "cc448d9d": [{
      "hkey": "39ab0fc6",
      "slug": "borghetto-santo-spirito",
      "name": "Borghetto Santo Spirito",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-danzio": [{
      "hkey": "39ab0fc6",
      "slug": "borghetto-santo-spirito",
      "name": "Borghetto Santo Spirito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d622a07": [{
      "hkey": "84b587c4",
      "slug": "castellaro-pineland",
      "name": "Castellaro-Pineland",
      "primary": true,
      "skipSearch": false
    }],
    "castellaro": [{
      "hkey": "84b587c4",
      "slug": "castellaro-pineland",
      "name": "Castellaro-Pineland",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "74d44715": [{
      "hkey": "4944e1e7",
      "slug": "centro-storico-giardini",
      "name": "Centro Storico-Giardini",
      "primary": true,
      "skipSearch": false
    }],
    "giardini": [{
      "hkey": "4944e1e7",
      "slug": "centro-storico-giardini",
      "name": "Centro Storico-Giardini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "725f2161": [{
      "hkey": "39ab0fc6",
      "slug": "borghetto-santo-spirito",
      "name": "Borghetto Santo Spirito",
      "primary": true,
      "skipSearch": false
    }],
    "patarello": [{
      "hkey": "39ab0fc6",
      "slug": "borghetto-santo-spirito",
      "name": "Borghetto Santo Spirito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4afdc453": [{
      "hkey": "39ab0fc6",
      "slug": "borghetto-santo-spirito",
      "name": "Borghetto Santo Spirito",
      "primary": true,
      "skipSearch": false
    }],
    "pontassi": [{
      "hkey": "39ab0fc6",
      "slug": "borghetto-santo-spirito",
      "name": "Borghetto Santo Spirito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;